import { apiClient, clean } from "./apiClient";
import type { PageRequest, PageResponse } from "@/types/api";
import type { BranchFilter, BranchSummary } from "@/types/entities";

export const branchesService = {
  list(filter: BranchFilter, page: PageRequest): Promise<PageResponse<BranchSummary>> {
    return apiClient
      .get<PageResponse<BranchSummary>>("/branches", { params: { ...clean(filter), ...clean(page) } })
      .then((r) => r.data);
  },
  getOne: (id: string) =>
    apiClient.get<BranchSummary>(`/branches/${id}`).then((r) => r.data),
  create: (body: { name: string; legalEntityId: string; email?: string;[key: string]: unknown }) =>
    apiClient.post("/branches", body).then((r) => r.data),
  // Atlas API treats PATCH /branches/{id} as a full replacement: any field
  // absent from the body is set to null on the row. Fetch the current record
  // first and merge the patch on top so the server receives the full entity
  // and only the explicitly-changed fields actually change.
  update: async (id: string, body: Record<string, unknown>) => {
    const current = await apiClient
      .get<Record<string, unknown>>(`/branches/${id}`)
      .then((r) => r.data);
    const merged = { ...current, ...body };
    return apiClient.patch(`/branches/${id}`, merged).then((r) => r.data);
  },
  remove: (id: string) =>
    apiClient.delete(`/branches/${id}`),
  // Mark this branch as the primary for its legal entity. The server clears the
  // flag on its siblings so at most one branch per legal entity is primary.
  setPrimary: (id: string) =>
    apiClient.post(`/branches/${id}/primary`).then((r) => r.data),
};